// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/operacional/services/crmDashboardService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type { CrmDashboard, AlertaCrm, DesempenhoVendedor } from '../types';

const BASE = '/api/crm/dashboard';

/** Recorte do dashboard/relatório (datas "yyyy-MM-dd" sobre a criação/solicitação). */
export interface FiltrosCrmDashboard {
  vendedorId?: number;
  clienteId?: number;
  de?: string;
  ate?: string;
}

/** O servidor já manda o nome (apelido) do vendedor. */
export type DesempenhoVendedorComNome = DesempenhoVendedor & { vendedorNome?: string | null };

export const crmDashboardService = {
  async obter(mesesEvolucao = 12, diasAtraso = 1, filtros: FiltrosCrmDashboard = {}): Promise<CrmDashboard> {
    const { data } = await apiClient.get<CrmDashboard>(BASE, {
      params: {
        mesesEvolucao, diasAtraso,
        vendedorId: filtros.vendedorId || undefined,
        clienteId: filtros.clienteId || undefined,
        de: filtros.de || undefined,
        ate: filtros.ate || undefined,
      },
    });
    return data;
  },

  async listarAlertas(diasAtraso = 1): Promise<AlertaCrm[]> {
    const { data } = await apiClient.get<AlertaCrm[]>(`${BASE}/alertas`, {
      params: { diasAtraso },
    });
    return data;
  },
};
